import { useEffect } from 'react';
import { useStores } from 'Hooks/useStore';
import { languageNames } from 'LearningManager/helpers/language';

export const useLanguageNames = () => {
	const { learningManagerStore } = useStores();

	useEffect(() => {
		learningManagerStore.fetchLanguages().catch(() => undefined);
	}, [learningManagerStore]);

	return (ids?: number[]) =>
		languageNames(ids, learningManagerStore.languagesById);
};

export default useLanguageNames;
